<template>
   <div>

    <VueFinalModal
      class="flex point justify-center fixed top-0 left-0 w-screen h-screen"
      content-class="flex flex-col w-full max-w-[600px] my-auto mx-4 bg-white rounded-lg overflow-hidden z-[1] outline-none focus:outline-none shadow-lg shadow-[rgba(0,0,0,.15)] relative"
      overlay-class="fixed pointer-events-none w-full h-full top-0 left-0 bg-black bg-opacity-50 z-[-1]"
      overlay-transition="fade"
      content-transition="scale-in"
      name="videoModal"
      :teleport-to="false"
      v-model="modals.video.show"
      @closed="modals.video.closed"
    >
        <button class="absolute flex items-center justify-center w-6 h-6 z-40 top-1.5 right-1.5 text-[#D24747] hover:text-white transition-[color,opacity] duration-300 rounded bg-rose-500" type="button" @click="modals.video.show = false">
            <svg class="w-5 h-5" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 14L34 34" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 34L34 14" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
        <ModalVideo v-if="activeItem && activeItem.type == 'video'" :item="activeItem">
        </ModalVideo>
    </VueFinalModal>


    <VueFinalModal
      class="flex point justify-center fixed top-0 left-0 w-screen h-screen"
      content-class="flex flex-col w-full max-w-[600px] my-auto mx-4 bg-white rounded-lg overflow-hidden z-[1] outline-none focus:outline-none shadow-lg shadow-[rgba(0,0,0,.15)] relative"
      overlay-class="fixed pointer-events-none w-full h-full top-0 left-0 bg-black bg-opacity-50 z-[-1]"
      overlay-transition="fade"
      content-transition="scale-in"
      name="photoModal"
      :teleport-to="false"
      v-model="modals.photo_set.show"
      @closed="modals.photo_set.closed"
    >
        <button class="absolute flex items-center justify-center w-9 h-9 z-50 top-1.5 right-1.5 text-white hover:text-rose-500 transition-[color,opacity] duration-300" type="button" @click="modals.photo_set.show = false">
            <svg class="w-6 h-6 z-50" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 14L34 34" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 34L34 14" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
        <ModalPhotos v-if="activeItem && activeItem.type == 'photo_set'" :item="activeItem">
        </ModalPhotos>
    </VueFinalModal>



   </div>
</template>
<script setup>

    import { VueFinalModal } from 'vue-final-modal'
    import { onMounted, onBeforeUnmount, ref, computed, watch, reactive } from 'vue';
    import { useRouter, useRoute, onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router'
    import { useMediaStore } from '../Stores/Media';

    import 'vue-final-modal/style.css'


    import ModalVideo from './MediaTypes/ModalVideo.vue';
    import ModalPhotos from './MediaTypes/ModalPhotos.vue';


    const router = useRouter()
    const route = useRoute()

    const modalOpen = ref(false)
    const modalFinished = ref(true)


    const store = useMediaStore();

    const activeItem = ref(null)
    const previousRoute = ref(null)

    const modals = reactive({
        video: {
            show: false,
            closed: () => {
                modals.video.show = false
                if ( previousRoute.value == 'media-root' ) {
                    router.back()
                } else {
                    router.push({path: '/'})
                }
            }
        },
        photo_set: {
            show: false,
            closed: () => {
                modals.photo_set.show = false
                console.log("ROUTE", route)
                if ( previousRoute.value == 'media-root' ) {
                    router.back()
                } else {
                    router.push({path: '/'})
                }
            }
        }
    })

    watch(
        () => route.params.slug,
        (newSlug, oldSlug) => {
            console.log('watching slug')
            console.log(newSlug)
            console.log(oldSlug)
            if ( newSlug ) {
                activeItem.value = { ...store.getMediaBySlug(newSlug) }
                console.log("ACTIVE", activeItem.value)
                if ( activeItem.value.type == 'video' ) {
                    modals.video.show = true
                } else if ( activeItem.value.type == 'photo_set' ) {
                    modals.photo_set.show = true
                }
            } else {
                activeItem.value = null
                modals.video.show = false
                modals.photo_set.show = false
            }
        },
        { immediate: true }
    )

    watch(
        () => route.name,
        (newName, oldName) => {
            previousRoute.value = oldName
        },
    )

    onMounted(() => {
        console.log('mounted')
    })

    onBeforeUnmount(() => {
        console.log('unmounted')
    })
</script>
